import { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import videoApi from '../../../../api/videoApi';
import api from '../../../../data/api';

export const useSavedVideos = userData => {
	const [savedVideos, setSavedVideos] = useState([]);
	const [refreshTrigger, setRefreshTrigger] = useState(null);

	// Fetch saved videos
	useEffect(() => {
		if (userData.token && userData.user?.userId) {
			videoApi
				.getAllSavedVideoIds(userData.user?.userId)
				.then(res => {
					setSavedVideos(res.data.savedVideos || []);
				})
				.catch(err => {
					console.error('Error fetching saved videos:', err);
				});
		}
	}, [userData.token, userData.user?.userId, refreshTrigger]);

	// Save/unsave video handler
	const handleSaveUnsave = useCallback(
		async (id, video) => {
			if (!userData.token) return;

			const isLiked =
				video.videoDetails?.savedvideo ||
				video.savedvideo ||
				savedVideos?.includes(video?.videoDetails?._id || video?._id) ||
				savedVideos?.includes(video?._id);

			try {
				let response;
				if (isLiked) {
					response = await api.unsaveWishlist(id, userData.token);
					if (response.status === 200) {
						toast.success('Unsaved', { position: 'top-center', duration: 3000 });
						setRefreshTrigger(response.data);
					}
				} else {
					response = await api.saveWishlist(id, userData.token);
					if (response.status === 200) {
						toast.success('Saved', { position: 'top-center', duration: 3000 });
						setRefreshTrigger(response.data);
					}
				}
			} catch (error) {
				console.error('Error saving/unsaving video:', error);
			}
		},
		[userData.token, savedVideos]
	);

	return {
		savedVideos,
		handleSaveUnsave
	};
};
